const listaDeCtrlFormulariosDinamicos = (state) => {
    return state.items;
}

const loadingFormularioDinamico = (state) => {
    return state.buscando
}

const listaDeExpressoesBooleanas = (state) => {
    return state.expressoesBooleanas
}

const formularioDinamico = (state) => {
    if (!state.formularioDinamico) {
        return []
    }
    
    if (Array.isArray(state.formularioDinamico)) {
        return state.formularioDinamico
    }
    
    return [state.formularioDinamico]
}

export {
    listaDeCtrlFormulariosDinamicos,
    loadingFormularioDinamico,
    listaDeExpressoesBooleanas,
    formularioDinamico
}